<template>
  <div class="extra-balls-section">
    <div class="eb-row random">
      <div class="eb-row-label">
        <p class="eb-row-label-text" data-langname="random">Nasumičnih</p>
      </div>
      <div class="eb-row-content random-btns-content">
        <button class="btn default random-btns six-seven" @click="randomSix(6)">
          6
        </button>
        <button class="btn default random-btns six-seven" @click="randomSix(7)">
          7
        </button>
      </div>
      <div class="eb-row-content random-btns-content">
        <button
          class="btn default random-btns eight-to-ten"
          @click="randomSix(8)"
        >
          8
        </button>
        <button
          class="btn default random-btns eight-to-ten"
          @click="randomSix(9)"
        >
          9
        </button>
        <button
          class="btn default random-btns eight-to-ten"
          @click="randomSix(10)"
        >
          10
        </button>
      </div>
    </div>
    <div class="eb-row extras">
      <div class="eb-extras-middle-buttons-col">
        <div class="eb-row-content extras-content">
         <button
          class="btn default extras-btns rearest btn-background"
          data-langname="quick_lucky_ball"
          @click="quickLuckyBalls"
        >
          Brzih 6
        </button>
      </div>
      <div class="eb-row-content extras-content">
        <button
          class="btn default extras-btns hotest btn-background"
          data-langname="hot_six"
          @click="setHotNumbers"
        >
          Najčešćih 6
        </button>
      </div>
      </div>
      <div class="eb-extras-middle-buttons-col">
        <div class="eb-row-content extras-content justify-end">
        <button
          class="btn default extras-btns btn-background"
          data-langname="all_colors"
          @click="setAllColors"
        >
          Sve Boje
        </button>
      </div>
      <div class="eb-row-content extras-content justify-end">
        <button
          class="btn default extras-btns rearest btn-background"
          data-langname="cold_six"
          @click="setCoolNumbers"
        >
          Najređih 6
        </button>
      </div>
      </div>
    </div>
    <div class="eb-row add">
      <div class="eb-row-content extras-content">
        <button class="btn default extras-btns add-to-slip" @click="addBallsToSlip">{{translate('add')}}
          <span class="ml-1" v-if="selectedNoOfBalls">({{ selectedNoOfBalls }})</span>
        </button>
      </div>
      <div class="eb-row-content extras-content clear-slip">
        <button class="btn default extras-btns clear-slip" data-langname="clear" @click="clearSelectedBalls" >OBRIŠI</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $eventBus from "../../eventBus";
import { translate } from "../../assets/common/lang";

export default {  
  props:['selectedNoOfBalls'],
  data() {
    return {
      minNumber: 1,
      maxNumber: 48,
    };
  },
  mounted() {
    this.$store.dispatch("getStatistics");
  },
  computed: {
    ...mapGetters(["allStatistics", "getQuickReplayDisabled"]),
  },
  methods: {
    translate(word) {
      return translate(word);
    },
    clearSelectedBalls() {
      this.$emit('clearSelectedBallsFromExtraBalls');
    },
    decodeNumbers(numbersString) {
      let numbers = numbersString.split("|");
      delete numbers[numbers.length - 1];
      delete numbers[0];

      let numbersNew = [];
      for (let x in numbers) {
        numbersNew.push(parseInt(numbers[x]));
      }
      return numbersNew;
    },
    setHotNumbers() {
      if (this.allStatistics && Object.keys(this.allStatistics).length) {
          this.$emit(
          "randomSix",
          this.decodeNumbers(
            this.allStatistics.HotNumbers ||
              console.error("Hot numbers error")
          ).sort((a, b) => a - b)
        );
      } else {
        //this.$socket.emit("lb-get-statistics");
      }
    },
    addBallsToSlip() {
      this.$emit('addBallsToSlip');
    },
    setCoolNumbers() {
       if (this.allStatistics && Object.keys(this.allStatistics).length) {
        this.$emit(
          "randomSix",
          this.decodeNumbers(
            this.allStatistics.CoolNumbers ||
              console.error("Cool numbers error")
          ).sort((a, b) => a - b)
        );
       } else {
         //this.$socket.emit("lb-get-statistics");
       }
    },
    randomSix(numbers) {
      this.$emit("randomSix", this.selectRandNumbers(numbers));
    },
    setAllColors() {
      this.$emit("setAllColors");
    },
    quickLuckyBalls() {
      if (!this.getQuickReplayDisabled) {
        $eventBus.$emit('clearAllBets');
        this.$store.dispatch("setQuickReplayDisabled", true);
        this.$store.dispatch('setSlip', []);
        this.$emit("quickRandomSix", this.selectRandNumbers());
      }
    },
    buyTicket() {
      $eventBus.$emit("quickLuckyBalls");
    },
    selectRandNumbers(range = 6) {
      let randNumbers = [];
      let counter = 0;
      while (counter < range) {
        const cycleRandNum = this.getRandomInt(this.minNumber, this.maxNumber);
        if (!randNumbers.includes(cycleRandNum)) {
          randNumbers.push(cycleRandNum);
          counter++;
        }
      }
      return randNumbers;
    },
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
  },
};
</script>
